import "../scss/style.scss";
import { Common } from "./modules/_common";
import { Home } from "./modules/_home";
import { Single } from "./modules/_single";
import { ToggleContents } from "./modules/_toggleContents";

Common();
Home();
Single();
ToggleContents();
